import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useTranslation } from 'react-i18next';
import { Div } from '../../../../layouts';
import { SlideGroupContext } from '../../../../components/SlideManager';
import { FieldType, EntryPoint, LegType } from '../../../../models';

function getTrackingAction(activeProduct) {
    if (activeProduct === EntryPoint.FLIGHTS) return 'searcher_flights';
    if (activeProduct === EntryPoint.TRAINS) return 'searcher_trains';
    return '';
}

function getTrackingFieldType(departureOrArrival) {
    return departureOrArrival === LegType.ARRIVAL ? 'dest' : 'orig';
}

export const FieldHeaderPrisma = ({
    extraTracking,
    textKey,
    text: textOverride,
    hasLocationInput,
    children,
    activeProduct,
    departureOrArrival,
    trackEvent,
}) => {
    const { t } = useTranslation();
    const text = textOverride || t(textKey);
    const context = React.useContext(SlideGroupContext);
    const currentSlideGroup = context.getCurrent();
    const shouldShowBack = currentSlideGroup.history.length > 1;

    const isTrainsOrFlights = activeProduct === EntryPoint.TRAINS || activeProduct === EntryPoint.FLIGHTS;
    const isLocationField = currentSlideGroup.active === 'DEPARTURE' || currentSlideGroup.active === 'ARRIVAL';
    const trackingFieldType = getTrackingFieldType(departureOrArrival);
    const trackingAction = getTrackingAction(activeProduct);

    const sendCloseTracking = (type) => {
        if (isTrainsOrFlights && isLocationField && trackEvent) {
            trackEvent({
                action: trackingAction,
                label: `searchbox_dest_close:${trackingFieldType}_type:${type}`,
            });
        }
    };

    const onClickHeaderCross = () => {
        if (currentSlideGroup.active === FieldType.DATE) extraTracking();
        sendCloseTracking('X');
        context.close();
    };

    const onClickHeaderBack = () => {
        sendCloseTracking('arr');
        context.prev();
    };

    const classNames = className({
        'odf-flex-container-row odf-flex-container-nogutter odf-flex-container-justify-between': true,
        'odf-space-inner-bottom-m': hasLocationInput,
    });

    return (
        <Div
            className="odf-header-mobile-prisma odf-header-mobile-shadow odf-space-inner-top-l
                odf-space-outer-bottom-s prisma-responsive-space-horizontal"
            height={hasLocationInput ? 'auto' : null}
            paddingBottom={hasLocationInput ? 10 : null}
        >
            <div className={classNames}>
                <Div
                    className="odf-flex-item"
                    onClick={onClickHeaderBack}
                    visibility={shouldShowBack ? 'visible' : 'hidden'}
                >
                    <span className="odf-icon odf-icon-2xl odf-icon-arrow-left-tail odf-icon-bidi odf-header-mobile-icon-color" />
                </Div>
                <div className="odf-flex-item">
                    <span className="prisma-lightbox-header-text odf-text-neutral-700">{text}</span>
                </div>
                <div
                    className="odf-flex-item odf-flex-item-sm"
                    onClick={onClickHeaderCross}
                >
                    <span className="odf-icon odf-icon-2xl odf-icon-cross-light odf-header-mobile-icon-color" />
                </div>
            </div>
            { hasLocationInput && (
                children
            )}
        </Div>
    );
};

FieldHeaderPrisma.propTypes = {
    extraTracking: PropTypes.func,
    textKey: PropTypes.string,
    text: PropTypes.string,
    children: PropTypes.node,
    hasLocationInput: PropTypes.bool,
    activeProduct: PropTypes.string,
    departureOrArrival: PropTypes.string,
    trackEvent: PropTypes.func,
};

FieldHeaderPrisma.defaultProps = {
    extraTracking: ()=>{},
    textKey: '',
    text: null,
    hasLocationInput: false,
    children: null,
    activeProduct: null,
    departureOrArrival: null,
    trackEvent: null,
};
